<section>
  <h2>Event Details</h2>
  <p-messages key="eventDetailMsg" [closable]="true"></p-messages>
  <form *ngIf="eventDetailsFormGroup" [formGroup]="eventDetailsFormGroup" class="w-lg-50">
    <ng-container formGroupName="ENESS_XREF_LECaseNumbers">
      <div class="mb-3">
        <label for="LECaseNumber" class="form-label required-field">Law enforcement case number (80 chars max)</label>
        <input id="LECaseNumber" type="text" formControlName="LECaseNumber" class="form-control" aria-required="true" maxlength="80" nessAutoFocus />
        <div class="invalid-feedback" [visible]="eventDetailsFormGroup.get('ENESS_XREF_LECaseNumbers.LECaseNumber').invalid">
          Please provide the law enforcement case number.
        </div>
      </div>
      <div class="mb-3">
        <label class="form-label" for="LEAlternateCaseNumber">Alternate law enforcement case number (80 chars max)</label>
        <input id="LEAlternateCaseNumber" type="text" formControlName="LEAlternateCaseNumber" class="form-control" maxlength="80" />
        <div class="invalid-feedback" *ngIf="eventDetailsFormGroup.get('ENESS_XREF_LECaseNumbers.LEAlternateCaseNumber').invalid">
          The alternate law enforcement case number can not exceed 80 characters.
        </div>
      </div>
      <div class="mb-3">
        <label class="form-label" for="NIBINAmendedLECaseNumber">NIBIN Case &#35;</label>
        <input id="NIBINAmendedLECaseNumber" type="text" formControlName="NIBINAmendedLECaseNumber" class="form-control" />
      </div>
    </ng-container>
    <ng-container formGroupName="ENESS_REF_Agency">
      <div class="mb-3">
        <ng-container formGroupName="ENESS_REF_Counties">
          <label for="stateID" class="form-label required-field">Agency state</label>
          <select id="stateID" class="form-select" formControlName="StateID" aria-required="true" required>
            <option value="">Select state</option>
            <ng-container *ngIf="lookupService.usStates$ | async as usStates">
              <option *ngFor="let state of usStates" [value]="state.StateID">{{state.StateName}}</option>
            </ng-container>
          </select>
          <div class="invalid-feedback">
            Please provide the agency state.
          </div>
        </ng-container>
      </div>
      <div class="mb-3">
        <label for="AgencyID" class="form-label required-field">Agency</label>
        <select id="AgencyID" class="form-select" formControlName="AgencyID" required aria-required="true" (change)="onAgencyChange($event['target'])">
          <option value="">Select agency</option>
          <ng-container *ngIf="filteredAgencies$ | async as agencies">
            <option *ngFor="let agency of agencies" [value]="agency.AgencyID" attr.data-tz="{{agency.ENESS_REF_Counties?.TimeZoneID}}">{{agency.AgencyName}}</option>
          </ng-container>
        </select>
        <div class="invalid-feedback">
          Please provide the agency.
        </div>
      </div>
    </ng-container>
    <div class="mb-3">
      <label for="EventDate" class="form-label required-field">Date and time event occurred</label>
      <p-calendar [required]="true" inputId="EventDate" formControlName="EventDateOffset" [defaultDate]="defaultEventDate" [showTime]="true" hourFormat="24" [showIcon]="true" [showOnFocus]="false" dateFormat="mm/dd/yy" styleClass="d-flex" inputStyleClass="form-control" [maxDate]="maxDateRule"></p-calendar>
      <div class="invalid-feedback">
        Please provide the date and time the event occurred.
      </div>
    </div>
    <div class="mb-3">
      <label for="timeZone" class="form-label required-field">Time zone</label>
      <select id="timeZone" class="form-select" formControlName="TimeZoneID" aria-required="true" (change)="onTimeZoneChange($event['target'])">
        <option value="">Select Time Zone</option>
        <option *ngFor="let timeZone of eventDataSvc.timeZones$ | async" value="{{timeZone.TimeZoneID}}">{{timeZone.TimeZoneName | timeZone}}</option>
      </select>
      <div class="invalid-feedback" [visible]="!eventDetailsFormGroup.get('TimeZoneID').value">
        Please provide the time zone.
      </div>
    </div>
    <div class="mb-3">
      <label for="eventStatus" class="form-label required-field">Event status</label>
      <select id="eventStatus" class="form-select" formControlName="StatusID" aria-required="true" required>
        <option value="">Select status</option>
        <option *ngFor="let status of eventDataSvc.statusesList$ | async" value="{{status.StatusID}}">{{status.Status}}</option>
      </select>
      <div class="invalid-feedback">
        Please provide the event status.
      </div>
    </div>
    <div class="mb-3" [hidden]="!showOtherStatus">
      <label for="OtherStatus" class="form-label required-field">Other status (80 chars max)</label>
      <input id="OtherStatus" type="text" formControlName="OtherStatus" class="form-control" required aria-required="true" maxlength="80" />
      <div class="invalid-feedback" [visible]="(eventDetailsFormGroup.get('OtherStatus').hasError('required') && eventDetailsFormGroup.get('OtherStatus').touched) || eventDetailsFormGroup.get('OtherStatus').pristine">
        Please provide the other event status.
      </div>
    </div>
    <div class="mb-3">
      <label for="crimeTypeID" class="form-label required-field">Crime type</label>
      <select id="crimeTypeID" class="form-select" formControlName="CrimeTypeID" aria-required="true" required>
        <option value="">Select crime type</option>
        <option *ngFor="let crimeType of eventDataSvc.crimeTypesDropdownList$ | async" value="{{crimeType.CrimeTypeID}}">{{crimeType.CrimeTypeName}}</option>
      </select>
      <div class="invalid-feedback">
        Please provide the event crime type.
      </div>
    </div>
    <div class="mb-3">
      <label for="OtherCrimeType" class="form-label" [class.required-field]="eventDataSvc.otherCrimeTypeId != null && eventDetailsFormGroup.get('CrimeTypeID').value === eventDataSvc.otherCrimeTypeId">Crime type (local terminology) (80 chars max)</label>
      <input id="OtherCrimeType" type="text" formControlName="OtherCrimeType" class="form-control" maxlength="80" [attr.required]="eventDataSvc.otherCrimeTypeId != null && eventDetailsFormGroup.get('CrimeTypeID').value === eventDataSvc.otherCrimeTypeId" aria-required="{{eventDataSvc.otherCrimeTypeId != null && eventDetailsFormGroup.get('CrimeTypeID').value === eventDataSvc.otherCrimeTypeId}}" />
      <div class="invalid-feedback" [visible]="(eventDetailsFormGroup.get('OtherCrimeType').hasError('required') && eventDetailsFormGroup.get('OtherCrimeType').touched) || eventDetailsFormGroup.get('OtherCrimeType').pristine">
        Please provide the crime type local terminology.
      </div>
    </div>
    <div class="mb-3">
      <label class="form-label" for="eventSummary">Event summary (1000 chars max)</label>
      <textarea [rows]="textAreaRows" id="eventSummary" formControlName="Summary" class="form-control"></textarea>
      <div class="invalid-feedback">
        The summary must not exceed 1000 characters.
      </div>
    </div>
    <div class="mb-3">
      <label class="form-label" for="eventNarrative">Event narrative (2,147,483,645 chars max)</label>
      <textarea [rows]="textAreaRows" id="eventNarrative" formControlName="Narrative" class="form-control"></textarea>
      <div class="invalid-feedback">
        The narrative must not exceed 2,147,483,645 characters.
      </div>
    </div>
    <div class="mb-3">
      <label class="form-label" for="analystNotes">Analyst notes (2,147,483,645 chars max)</label>
      <textarea [rows]="textAreaRows" id="analystNotes" formControlName="Notes" class="form-control"></textarea>
      <div class="invalid-feedback">
        The analyst notes must not exceed 2,147,483,645 characters.
      </div>
    </div>
    <div class="mb-3">
      <p-messages key="eventLEPartnerMsg" [closable]="true"></p-messages>
      <table class="temp-bs table table-sm table-striped table-bordered">
        <caption class="caption-top form-label text-body">LE Partner</caption>
        <thead>
          <tr>
            <th scope="col">First name</th>
            <th scope="col">Middle name</th>
            <th scope="col">Last name</th>
            <th scope="col" class="w-10"><span class="visually-hidden">Delete</span></th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="lePartners.length == 0;else partnersrows">
            <tr><td colspan="4">No LE partners found.</td></tr>
          </ng-container>
          <ng-template #partnersrows>
            <tr *ngFor="let partner of lePartners; let i = index">
              <th scope="row">
                <button type="button" class="btn btn-link" aria-label="View partner details" (click)="viewLEPartnerDetails(partner.LEPartnerStagingID)">{{partner.FirstName}}</button>
              </th>
              <td>{{partner.MiddleName}}</td>
              <td>{{partner.LastName}}</td>
              <td class="text-center">
                <button type="button" title="Delete LE Partner" (click)="removeLEPartner(i)" class="btn btn-sm btn-danger"><i class="fas fa-times" aria-hidden="true"></i><span class="visually-hidden">Delete LE Partner</span></button>
              </td>
            </tr>
          </ng-template>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="4" class="p-2">
              <div class="my-2" [formGroup]="eventPartnerForm">
                <label class="form-label" for="LEPartnerID">LE Partner</label>
                <select #lepartners id="LEPartnerID" class="form-select" formControlName="LEPartnerID">
                  <option value="">Select partner</option>
                  <ng-container *ngIf="filteredLEPartners$ | async as partners">
                    <option *ngFor="let partner of partners;" value="{{partner?.LEPartnerID || partner?.LEPartnerStagingID}}">{{partner?.FirstName}} {{partner?.MiddleName}} {{partner?.LastName}}</option>
                  </ng-container>
                </select>
              </div>
              <div class="mt-3">
                <button type="button" class="btn btn-sm btn-success me-sm-3 mb-2" [disabled]="eventPartnerForm.get('LEPartnerID').disabled || eventPartnerForm.get('LEPartnerID').invalid || !eventDetailsFormGroup.get('ENESS_REF_Agency.AgencyID').value" (click)="addLEPartnerToEvent(lepartners.selectedIndex)"><i class="fa fa-plus" aria-hidden="true"></i> Add Selected LE Partner</button>
                <button type="button" class="btn btn-sm btn-success mb-2" [disabled]="!eventDetailsFormGroup.get('ENESS_REF_Agency.AgencyID').value" (click)="addNewLEPartner()"><i class="fa fa-plus" aria-hidden="true"></i> Add A New LE Partner</button>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </form>
</section>
<aside>
  <p-sidebar #sb [(visible)]="displaySidebar" position="right" styleClass="p-sidebar-lg" [blockScroll]="true" [showCloseIcon]="false" (onHide)="onLEPartnerClose()">
    <ng-container *ngIf="openNewLEPartnerForm">
      <ng-container *ngIf="eventDataSvc.lePartnerDetails$ | async as lePartner">
        <ness-lepartner-form [eventAgencyId]="eventDetailsFormGroup.get('ENESS_REF_Agency.AgencyID').value" [lePartner]="lePartner" [isEventForm]="true" [titleText]="partnerFormTitleText" (onAddOrUpdatePartner)="onNewPartnerAdded($event)" (closeForm)="onLEPartnerClose()"></ness-lepartner-form>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="openViewLEPartner">
      <ng-container *ngIf="eventDataSvc.lePartnerDetails$ | async as lePartner">
        <ness-lepartner-view-form [lePartner]="lePartner" [isEventForm]="true" (closeForm)="onLEPartnerClose()" (onLEPartnerEdit)="addNewLEPartner($event)"></ness-lepartner-view-form>
      </ng-container>
    </ng-container>
  </p-sidebar>
</aside>
